var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 50,
    viewBox: "0 0 31 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6154 38.323L29.6774 30.1584C30.4994 28.7691 30.958 26.9225 30.958 25.0021C30.958 23.0818 30.4994 21.2352 29.6774 19.8459L24.6154 11.6813C24.4366 11.3828 24.2228 11.1447 23.9865 10.981C23.7501 10.8172 23.4958 10.731 23.2386 10.7274C22.9813 10.7238 22.7262 10.8028 22.4881 10.96C22.25 11.1171 22.0336 11.3491 21.8517 11.6426C21.6698 11.936 21.5259 12.2849 21.4285 12.6689C21.3311 13.053 21.2821 13.4645 21.2843 13.8794C21.2866 14.2944 21.34 14.7044 21.4415 15.0857C21.5431 15.4669 21.6907 15.8118 21.8757 16.1L25.4653 21.8938L1.89237 21.9417C1.37851 21.9417 0.8857 22.271 0.522348 22.857C0.158997 23.4431 -0.0451336 24.2379 -0.0451336 25.0667C-0.0451336 25.8955 0.158997 26.6904 0.522348 27.2764C0.8857 27.8625 1.37851 28.1917 1.89237 28.1917L25.4459 28.1438L21.8757 33.9042C21.5228 34.4936 21.3275 35.283 21.3319 36.1023C21.3364 36.9217 21.5401 37.7055 21.8993 38.2849C22.2586 38.8643 22.7445 39.193 23.2525 39.2001C23.7605 39.2072 24.25 38.8922 24.6154 38.323Z",
    fill: "#427D9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 50,
    fill: "white",
    transform: "matrix(-1 0 0 -1 31 50.0022)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.accabc0a6aafefa4c73dbbea0912a759.svg";
export { ForwardRef as ReactComponent };